import { render } from "./AddMeldingOpvolgenView.vue?vue&type=template&id=228d4503&scoped=true"
import script from "./AddMeldingOpvolgenView.vue?vue&type=script&lang=js"
export * from "./AddMeldingOpvolgenView.vue?vue&type=script&lang=js"

import "./AddMeldingOpvolgenView.vue?vue&type=style&index=0&id=228d4503&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228d4503"]])

export default __exports__